import { ChevronRightOutlined } from '@mui/icons-material';
import {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  styled,
  Tooltip,
} from '@mui/material';
import { ExtendedListItemText } from '@procureai/ui-mui';
import { ReactNode, SyntheticEvent } from 'react';

const ListItemButtonStyled = styled((props: ListItemButtonProps) => <ListItemButton {...props} />)(({ theme }) => ({
  height: '100%',
  paddingRight: 0,
  backgroundColor: theme.palette.grey[100],
  borderRadius: 4,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

interface GuidedDialogActionProps {
  onClick: (event: SyntheticEvent) => void;
  title?: ReactNode;
  description?: ReactNode;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  disabled?: boolean;
  disabledTooltipTitle?: string;
}
export const GuidedDialogAction = ({
  title,
  description,
  startIcon,
  endIcon,
  disabled,
  disabledTooltipTitle,
  onClick,
}: GuidedDialogActionProps) => {
  const content = (
    <ListItem disablePadding>
      <ListItemButtonStyled sx={{}} disabled={disabled} onClick={onClick}>
        {startIcon && <ListItemAvatar>{startIcon}</ListItemAvatar>}
        <ExtendedListItemText primary={title} secondary={description} />
        <ListItemIcon>{endIcon ?? <ChevronRightOutlined />} </ListItemIcon>
      </ListItemButtonStyled>
    </ListItem>
  );

  return (
    <>
      {disabled && disabledTooltipTitle ? (
        <Tooltip arrow title={disabledTooltipTitle}>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </>
  );
};
